<template>
    <div>
        <a-drawer title="" width="550" placement="right" @close="onClose" :visible="drawerVisible">
            <div v-if="formType == 'g'">
                <h6 class="heading-small text-muted mb-4">Combo Group</h6>  
                <base-input label="Name">
                    <a-input type="text" v-model="comboGroup.name"/>
                </base-input>
                <base-input label="Group Index">
                    <a-input type="number" v-model="comboGroup.groupIndex"/>
                </base-input>
                <base-input label="Minimum Quantity">
                    <a-input type="number" v-model="comboGroup.minQty"/>
                </base-input>
                <base-input label="Maximum Quantity">
                    <a-input type="number" v-model="comboGroup.maxQty"/>
                </base-input>
                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-success" @click.prevent="saveGroup">Save</button>
                    <button class="btn" @click.prevent="onClose">Cancel</button>
                </div>
            </div>
            <div v-if="formType == 'p'">
                <h6 class="heading-small text-muted mb-4">Combo Product</h6>  
                <base-input label="Barcode Search" v-if="formMode == 'a'">
                    <a-input type="text" v-model="barcodeSearch" @keyup.enter="searchProduct"/>
                    <small><span class="fa fa-info-circle"/> Search the barcode of the product you wish to add on the selected combo group</small>
                </base-input>
                <div v-if="comboProduct.id != null">
                    <base-input label="Name">
                        <a-input type="text" v-model="comboProduct.name"/>
                        <small v-if="comboProduct != null"> PHP {{comboProduct.retail_price}}</small>
                    </base-input>
                    <base-input label="Additional Price">
                        <a-input type="number" v-model="comboProduct.additionalPrice"/>
                    </base-input>
                    <base-input label="Minimum Quantity">
                        <a-input type="number" v-model="comboProduct.minQty"/>
                    </base-input>
                    <base-input label="Maximum Quantity">
                        <a-input type="number" v-model="comboProduct.maxQty"/>
                    </base-input>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                        <button class="btn btn-success" @click.prevent="saveProduct">Save</button>
                        <button class="btn" @click.prevent="onClose">Cancel</button>
                    </div>
                </div>
            </div>
            <div v-if="formType == 'v'">
                <h6 class="heading-small text-muted mb-4">Product Variants</h6>  
                <base-input label="Variant Selection" class="col-md-12">
                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="comboVariant.id">
                        <a-select-option v-for="v in variantSelection" :key="v.id" :value="v.id">{{v.name}}</a-select-option>
                    </a-select>
                </base-input>
                <base-input label="Name">
                    <a-input type="text" v-model="comboVariant.name"/>
                </base-input>
                <base-input label="Additional Price">
                    <a-input type="number" v-model="comboVariant.additionalPrice"/>
                </base-input>
                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-success" @click.prevent="saveVariant">Save</button>
                    <button class="btn" @click.prevent="onClose">Cancel</button>
                </div>
            </div>
        </a-drawer>

        <h3>Combo Meal Definition</h3>
        <!-- {{comboGroups}} -->
        <div class="row align-items-center">

          <!-- GROUPS -->
          <div class="col-md-4 col-sm-4" style="padding:0px; border-right: 1px #E9ECEF solid; height: 300px;">
            <ul class="list-group list-group-flush">
                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                    <div class="row">
                          <div class="col-md-8">COMBO GROUP</div>
                          <div class="col-md-4 float-right">
                              <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showComboDrawer('g', 'a')"><span class="fa fa-plus"/> </base-button>
                          </div>
                    </div>
                </li>
                <div style="height: 545px; overflow-y: scroll;">
                  <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                  <li class="list-group-item" style="font-size: 14px" v-for="group in comboGroups" :key="group.name" :class="[{selected2: comboGroupName == group.name}]">
                     <div class="row" @click="selectGroup(group)">
                        <div class="col-md-8">
                            <a-dropdown v-if="comboGroupName == group.name">
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span> 
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item @click="showComboDrawer('g', 'e')"> Edit - {{group.name}} </a-menu-item>
                                <a-menu-item  key=2 > 
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete" cancelText="Cancel" @confirm="deleteGroup()">
                                    Delete - {{group.name}}
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp; 
                            {{group.name}}
                        </div>
                        <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                     </div>
                  </li>
                </div>
            </ul>
          </div>

          <!-- PRODUCTS -->
          <div class="col-md-4 col-sm-4" style="padding:0px; border-right: 1px #E9ECEF solid; height: 300px;">
            <ul class="list-group list-group-flush">
                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                    <div class="row">
                          <div class="col-md-8">PRODUCTS</div>
                          <div class="col-md-4 float-right">
                              <base-button :disabled="comboGroupName == null" class="float-right ml-1" type="primary" size="sm" @click.prevent="showComboDrawer('p', 'a')"><span class="fa fa-plus"/> </base-button>
                          </div>
                        <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                    </div>
                </li>
            </ul>
            <div style="height: 545px; overflow-y: scroll;">
                  <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                  <li class="list-group-item" style="font-size: 14px" v-for="product in comboProducts" :key="product.id" :class="[{selected2: comboProductId == product.id}]">
                     <div class="row" @click="selectProduct(product)">
                        <div class="col-md-8">
                            <a-dropdown v-if="comboProductId == product.id">
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span> 
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item @click="showComboDrawer('p', 'e')"> Edit - {{product.name}} </a-menu-item>
                                <a-menu-item  key=2 > 
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete" cancelText="Cancel" @confirm="deleteProduct()">
                                    Delete - {{product.name}}
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp; 
                            {{product.name}}
                        </div>
                        <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                     </div>
                  </li>
                </div>
          </div>

          <!-- VARIANTS -->
          <div class="col-md-4 col-sm-4" style="padding:0px; height: 300px;">
            <ul class="list-group list-group-flush">
                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                    <div class="row">
                          <div class="col-md-8">VARIANTS</div>
                          <div class="col-md-4 float-right">
                              <base-button :disabled="comboProduct.product_type != 'M'" class="float-right ml-1" type="primary" size="sm" @click.prevent="showComboDrawer('v', 'a')"><span class="fa fa-plus"/> </base-button>
                              <!-- <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('t', 'a')"><span class="fa fa-plus"/> </base-button> -->
                          </div>
                        <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                    </div>
                </li>
                <div v-if="comboProduct.product_type == 'M'" style="height: 545px; overflow-y: scroll;">
                  <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                  <li class="list-group-item" style="font-size: 14px" v-for="variant in comboVariants" :key="variant.id" :class="[{selected2: comboVariantId == variant.id}]">
                     <div class="row" @click="selectVariant(variant)">
                        <div class="col-md-12">
                            <a-dropdown v-if="comboVariantId == variant.id">
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span> 
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item @click="showComboDrawer('v', 'e')"> Edit - {{variant.name}} </a-menu-item>
                                <a-menu-item  key=2 > 
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete" cancelText="Cancel" @confirm="deleteVariant()">
                                    Delete - {{variant.name}}
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                              </a-menu>
                            </a-dropdown> &nbsp; 
                            {{variant.name}}
                        </div>
                        <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                     </div>
                  </li>
                </div>
                <div v-else style="height: 545px; overflow-y: scroll;">
                       <a-empty class='mt-5' :image-style="{height: '50px',}" >
                           <span slot="description"> No variant available for the selected product. </span>
                       </a-empty>
                 </div>
            </ul>
          </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex'
    import HTTPRequest from '../../controllers/httpRequest.js'

    export default {
        data: function () {
            return {
                drawerVisible: false,
                formType: "g",
                formMode: "a",

                comboGroups: [],
                comboGroup: {},
                comboGroupName: null,

                barcodeSearch: null,
                comboProducts: [],
                comboProduct: {},
                comboProductId: null,

                comboVariants: [],
                comboVariant: {},
                comboVariantId: null,
                variantSelection: []
            }
        },
        computed: {
            ...mapState(['endPoint', 'publicUrl'])
        },
        methods: {
            showComboDrawer(type, mode){
                this.formType = type
                this.formMode = mode
                this.drawerVisible = true
                if(this.formType == 'g' && this.formMode == 'a'){
                    this.comboGroup = {}
                    this.comboProducts = []
                    this.comboProduct = {}
                    this.comboVariants = []
                    this.comboVariant = {}
                }
                if(this.formType == 'p' && this.formMode == 'a'){
                    this.comboProduct = {}
                    this.comboVariants = []
                    this.comboVariant = {}
                }
                if(this.formType == 'v' && this.formMode == 'a'){
                    this.comboVariant = {}
                }
            },
            onClose(){
                this.drawerVisible = false
            },
            selectGroup(group){
              this.comboGroup = Object.assign({}, group)
              this.comboGroupName = group.name  
              this.comboVariants = []
              this.comboVariant = {}
              this.comboProduct = {}
              this.comboProducts = this.comboGroup.items
            },
            saveGroup(){
                if(this.formMode == 'a'){
                    this.comboGroup.items = []
                    this.comboGroups.push(this.comboGroup)
                    this.comboGroup = {}
                } else {
                    //Find index of specific object using findIndex method.    
                    let objIndex = this.comboGroups.findIndex((obj => obj.name == this.comboGroupName));
                    this.comboGroups[objIndex] = this.comboGroup
                    this.comboGroupName = this.comboGroup.name
                }
                this.drawerVisible = false
            }, 
            deleteGroup(){
                let objIndex = this.comboGroups.findIndex((obj => obj.name == this.comboGroupName));
                this.comboGroups.splice(objIndex, 1)
                this.comboProducts = []
                this.comboVariants = []
            }, 
            async searchProduct(){
                var product = await HTTPRequest.getRequest(this.endPoint + 'products?search_type=B&barcode=' + this.barcodeSearch , null);
                if(product.data.length > 0){
                    this.comboProduct = product.data[0]
                         this.$message['success'](
                            "Product found."
                        );
                }else{
                    this.$message['error'](
                            "Product not found. Please search another barcode."
                    );
                    this.comboProduct = {}
                }
            },
            saveProduct(){
                if(this.formMode == "a"){
                    if(this.comboProduct.id != null || this.comboProduct.id != undefined){
                        let tempProduct = {name: this.comboProduct.name, minQty: this.comboProduct.minQty, maxQty: this.comboProduct.maxQty, id: this.comboProduct.id, product_type: this.comboProduct.product_type, variantsOverride: []}
                        this.comboGroup.items.push(tempProduct)
                        this.drawerVisible = false
                    }else{
                        this.$message['error'](
                            "Product must exist."
                        );
                    }
                } else {
                    let objIndex = this.comboGroup.items.findIndex((obj => obj.id == this.comboProductId));
                    this.comboGroup.items[objIndex] = this.comboProduct
                    this.drawerVisible = false
                }
            },
            deleteProduct(){
                let objIndex = this.comboGroup.items.findIndex((obj => obj.id == this.comboProductId));
                this.comboGroup.items.splice(objIndex, 1)
                this.comboVariants = []
            }, 
            async selectProduct(product){
              this.comboProduct = Object.assign({}, product)
              this.comboProductId = product.id  
              if(this.comboProduct.product_type == "M"){
                  this.comboVariants = this.comboProduct.variantsOverride
                  var product = await HTTPRequest.getRequest(this.endPoint + 'products?search_type=P&matrix_parent_id=' + this.comboProductId , null);
                  this.variantSelection = product.data
              }
            //   this.comboVariants = this.com.items
            //   this.comboVariant = {}
            },
            saveVariant(){
                if(this.formMode == "a"){
                    let tempVariant = {id: this.comboVariant.id, name: this.comboVariant.name, additionalPrice: this.comboVariant.additionalPrice}
                    // let tempProduct = {name: this.comboProduct.name, minQty: this.comboProduct.minQty, maxQty: this.comboProduct.maxQty, id: this.comboProduct.id, product_type: this.comboProduct.product_type}
                    this.comboProduct.variantsOverride.push(tempVariant)
                    this.selectProduct(this.comboProduct)
                    this.drawerVisible = false
                } else {
                    let objIndex = this.comboProduct.variantsOverride.findIndex((obj => obj.id == this.comboVariantId));
                    this.comboProduct.variantsOverride[objIndex] = this.comboVariant
                    this.drawerVisible = false
                }
            },
            async selectVariant(variant){
              this.comboVariant = Object.assign({}, variant)
              this.comboVariantId = variant.id  
            //   if(this.comboProduct.product_type == "M"){
            //       this.comboVariants = this.comboProduct.variantsOverride
            //       var product = await HTTPRequest.getRequest(this.endPoint + 'products?search_type=P&matrix_parent_id=' + this.comboProductId , null);
            //       this.variantSelection = product.data
            //   }
            //   this.comboVariants = this.com.items
            //   this.comboVariant = {}
            },
            deleteVariant(){
                let objIndex = this.comboProduct.variantsOverride.findIndex((obj => obj.id == this.comboVariantId));
                this.comboProduct.variantsOverride.splice(objIndex, 1)
            }, 
        }
    }
</script>